<template>
  <div class="star-rating">
    <span
      v-for="(star, index) in ratingMaximum"
      :key="index"
      class="star"
    >
      <span 
        class="fill" 
        :style="{ width: getStyle(index)}"
      >★</span>
      <span class="empty">★</span>
    </span>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ ratingTotal: number; ratingMaximum: number }>();

const getStyle = (index: number) => (props.ratingTotal > index ? (Math.min(1, props.ratingTotal - index) * 100) + '%' : '0%' );

</script>

<style scoped>
.star-rating {
  display: inline-flex;
  gap: 2px;
}

.star {
  position: relative;
  font-size: 11px;
  display: inline-block;
}

.fill {
  position: absolute;
  overflow: hidden;
  white-space: nowrap;
  color: theme('colors.green.40');
  left: 0;
  top: 0;
  height: 100%;
}

.empty {
  color: transparent;
  -webkit-text-stroke: 1px theme('colors.neutral.60');
}
</style>